import {uuidv4} from '../../../@shared/ts/uuid';
import {setSessionId} from '../reducers/peachPayOrderReducer';
import {store} from '../store';

interface IPeachPaySession {
	'key': string;
	'metadata'?: Record<string, any>;
	'created_on': string;
}

const PEACHPAY_SESSION_KEY = 'PP_SESSION_KEY';

function createSession(): IPeachPaySession {
	// Creating the peachpay session on the client now because it changes on every
	// page load anyways and the server should be stateless. Session ID can be used as a
	// tracer though the logs.
	const key = `session_${uuidv4()}`;

	return {
		key,
		created_on: new Date().toJSON(),
	};
}

function getSession(): IPeachPaySession {
	const getData = () => {
		try {
			return sessionStorage.getItem(PEACHPAY_SESSION_KEY);
		} catch {
			return null;
		}
	};

	const sessionData = getData();

	const parseSession = (data: string | null) => {
		if (!data) {
			return createSession();
		}

		const session = JSON.parse(data) as IPeachPaySession;

		const currentDate = new Date();
		const sessionDate = new Date(session.created_on);
		// If session is older then 5 days create a new one.
		if ((currentDate.getMilliseconds() - sessionDate.getMilliseconds()) > 432_000_000) {
			return createSession();
		}

		return session;
	};

	return parseSession(sessionData);
}

function saveSession(session: IPeachPaySession): boolean {
	try {
		sessionStorage.setItem(PEACHPAY_SESSION_KEY, JSON.stringify(session));
		return true;
	} catch {
		return false;
	}
}

/**
 * Loads an exisiting session or creates a new one if one does not exist or is expired.
 */
function loadSession() {
	const session = getSession();

	store.dispatch(setSessionId(session.key));

	saveSession(session);
}

/**
 * Clears the local session only from the sessionStorage.
 */
function clearLocalSession(): void {
	try {
		sessionStorage.removeItem(PEACHPAY_SESSION_KEY);
	} catch {
		// Do no harm
	}
}

export {clearLocalSession, loadSession};
